import { render } from "./SpacingPlaygroud.vue?vue&type=template&id=0b5d103e"
import script from "./SpacingPlaygroud.vue?vue&type=script&lang=js"
export * from "./SpacingPlaygroud.vue?vue&type=script&lang=js"

import "./SpacingPlaygroud.vue?vue&type=style&index=0&id=0b5d103e&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__